// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Respaldo visible cuando un subárbol falla.

  📌 Se ve como una tarjeta del propio dashboard y no como una pantalla de error del navegador. El objetivo es que
  se lea como "esta sección no cargó" y no como "la aplicación murió" — que es la conclusión que hace cerrar la
  pestaña.
*/

.ErrorBoundary_host__FH3R9 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  padding: 40px 24px 32px;
  margin: 8px 0;
  border-radius: 16px;
  /* 15-oct-2026: \`--dylo-card-bg\` no existe; la superficie de las tarjetas es esta. */
  background: var(--dylo-surface);
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 32%, transparent);
}

.ErrorBoundary_icon__3A7kN {
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  border-radius: 16px;
  margin-bottom: 2px;
  color: var(--dylo-danger);
  background: color-mix(in srgb, var(--dylo-danger) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 32%, transparent);
}

.ErrorBoundary_title__MXoFz {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: var(--dylo-ink);
}

.ErrorBoundary_text__-M0uW {
  margin: 0;
  max-width: 520px;
  font-size: 13px;
  line-height: 1.55;
  color: var(--dylo-muted);
}

.ErrorBoundary_actions__W3nFD {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}

.ErrorBoundary_retryBtn__YyCnF {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  appearance: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 16px;
  border-radius: 10px;
  color: var(--dylo-ink);
  background: transparent;
  border: 1px solid var(--dylo-border);
  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease;
}
.ErrorBoundary_retryBtn__YyCnF:hover {
  background: var(--dylo-surface-2);
  border-color: color-mix(in srgb, var(--dylo-orange) 40%, var(--dylo-border));
}
.ErrorBoundary_retryBtn__YyCnF:active {
  transform: scale(0.97);
}

/* El detalle técnico, colapsado. Quien reporta necesita copiarlo; a quien solo quiere seguir no le sirve. */
.ErrorBoundary_details__Zxweg {
  margin-top: 14px;
  max-width: 100%;
  text-align: left;
}
.ErrorBoundary_summary__tqpeX {
  cursor: pointer;
  font-size: 12px;
  color: var(--dylo-muted);
  -webkit-user-select: none;
          user-select: none;
}
.ErrorBoundary_summary__tqpeX:hover {
  color: var(--dylo-ink);
}
.ErrorBoundary_pre__WdTMx {
  margin: 8px 0 0;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 11.5px;
  line-height: 1.5;
  color: var(--dylo-text);
  background: var(--dylo-surface-2);
  border: 1px solid var(--dylo-border);
  /* ⚠️ \`pre-wrap\` y \`break-word\`: un mensaje de error largo con un \`pre\` normal estira el contenedor y saca una
     barra horizontal a toda la pantalla. */
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 180px;
  overflow: auto;
}

@media (prefers-reduced-motion: reduce) {
  .ErrorBoundary_retryBtn__YyCnF:active {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ErrorBoundary.module.css"],"names":[],"mappings":"AAAA;;;;;;CAMC;;AAED;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,oFAAoF;EACpF,+BAA+B;EAC/B,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mEAAmE;EACnE,yEAAyE;AAC3E;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,gFAAgF;AAClF;AACA;EACE,iCAAiC;EACjC,4EAA4E;AAC9E;AACA;EACE,sBAAsB;AACxB;;AAEA,4GAA4G;AAC5G;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,oCAAoC;EACpC;2CACyC;EACzC,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/*\n  Respaldo visible cuando un subárbol falla.\n\n  📌 Se ve como una tarjeta del propio dashboard y no como una pantalla de error del navegador. El objetivo es que\n  se lea como \"esta sección no cargó\" y no como \"la aplicación murió\" — que es la conclusión que hace cerrar la\n  pestaña.\n*/\n\n.host {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  text-align: center;\n  padding: 40px 24px 32px;\n  margin: 8px 0;\n  border-radius: 16px;\n  /* 15-oct-2026: `--dylo-card-bg` no existe; la superficie de las tarjetas es esta. */\n  background: var(--dylo-surface);\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 32%, transparent);\n}\n\n.icon {\n  display: grid;\n  place-items: center;\n  width: 54px;\n  height: 54px;\n  border-radius: 16px;\n  margin-bottom: 2px;\n  color: var(--dylo-danger);\n  background: color-mix(in srgb, var(--dylo-danger) 10%, transparent);\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 32%, transparent);\n}\n\n.title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n}\n\n.text {\n  margin: 0;\n  max-width: 520px;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--dylo-muted);\n}\n\n.actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.retryBtn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  appearance: none;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 9px 16px;\n  border-radius: 10px;\n  color: var(--dylo-ink);\n  background: transparent;\n  border: 1px solid var(--dylo-border);\n  transition: background 0.16s ease, border-color 0.16s ease, transform 0.16s ease;\n}\n.retryBtn:hover {\n  background: var(--dylo-surface-2);\n  border-color: color-mix(in srgb, var(--dylo-orange) 40%, var(--dylo-border));\n}\n.retryBtn:active {\n  transform: scale(0.97);\n}\n\n/* El detalle técnico, colapsado. Quien reporta necesita copiarlo; a quien solo quiere seguir no le sirve. */\n.details {\n  margin-top: 14px;\n  max-width: 100%;\n  text-align: left;\n}\n.summary {\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--dylo-muted);\n  user-select: none;\n}\n.summary:hover {\n  color: var(--dylo-ink);\n}\n.pre {\n  margin: 8px 0 0;\n  padding: 10px 12px;\n  border-radius: 10px;\n  font-size: 11.5px;\n  line-height: 1.5;\n  color: var(--dylo-text);\n  background: var(--dylo-surface-2);\n  border: 1px solid var(--dylo-border);\n  /* ⚠️ `pre-wrap` y `break-word`: un mensaje de error largo con un `pre` normal estira el contenedor y saca una\n     barra horizontal a toda la pantalla. */\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-height: 180px;\n  overflow: auto;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .retryBtn:active {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"host": `ErrorBoundary_host__FH3R9`,
	"icon": `ErrorBoundary_icon__3A7kN`,
	"title": `ErrorBoundary_title__MXoFz`,
	"text": `ErrorBoundary_text__-M0uW`,
	"actions": `ErrorBoundary_actions__W3nFD`,
	"retryBtn": `ErrorBoundary_retryBtn__YyCnF`,
	"details": `ErrorBoundary_details__Zxweg`,
	"summary": `ErrorBoundary_summary__tqpeX`,
	"pre": `ErrorBoundary_pre__WdTMx`
};
export default ___CSS_LOADER_EXPORT___;
